import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import PDFDownload from "../SvgIcons/Pdf";
import Swal from "sweetalert2";

import { formatCountryDate } from "../../Services/countryTime";
export default function PdfEventWiseUsersReport({ data = [] }) {
  // Format date
  function formatDate(dateStr) {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return formatCountryDate(d).replace(/\//g, "-");
  }

  // Format time
  function formatTime(timeStr) {
    if (!timeStr) return "";
    const [hour, minute] = timeStr.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
  }

  const handleDownloadPdf = () => {
    if (!data || !data.length) {
      Swal.fire({
        icon: "warning",
        title: "Notice",
        text: "Select at least one event user to download.",
      });
      return;
    }

    // Group data by Title + Event Date + Time
    const grouped = data.reduce((acc, item) => {
      const timeRange = `(${formatTime(item.StartTime)} to ${formatTime(item.EndTime)})`;
      const groupKey = `${item.Title} - ${formatDate(item.event_date)} ${timeRange}`;
      if (!acc[groupKey]) acc[groupKey] = [];
      acc[groupKey].push(item);
      return acc;
    }, {});

    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.width;

    // ---------------- Main Title ----------------
    const confirmationName = data[0]?.confirmation || "Unknown";
    const title = `Event Registrations by ${confirmationName} - Total: ${data.length}`;
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFillColor(56, 89, 142);
    doc.rect(0, 5, pageWidth, 10, "F");
    doc.text(title, pageWidth / 2, 12, { align: "center" });

    let startY = 25;

    // ---------------- Event Groups ----------------
    Object.entries(grouped).forEach(([eventTitle, records]) => {
      // Bold Event Title Row
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold"); // bold
      doc.setFillColor(204, 229, 255); // light blue
      doc.rect(10, startY - 6, pageWidth - 20, 10, "F");
      doc.text(eventTitle, pageWidth / 2, startY, { align: "center" });
      doc.setFont("helvetica", "normal"); // reset to normal
      startY += 5;

      // Table Headers
      const tableHeaders = [
        [
          "Sr.No.",
          "Name",
          "Email",
          "Mobile no.",
          "Organization Name",
          "Tally Number",
          "Participants",
          "Registration Date",
          "Mode of Meeting",
        ],
      ];

      // Table Data
      const tableData = records.map((item, index) => [
        index + 1,
        item.name || "-",
        item.email || "-",
        item.mobile || "-",
        item.organization || "-",
        item.tallynumber || "-",
        item.NoOfParticipants || "-",
        formatDate(item.registration_date) || "-",
        item.ModeOfMeeting || "-",
      ]);

      autoTable(doc, {
        startY: startY + 5,
        head: tableHeaders,
        body: tableData,
        theme: "grid",
        tableWidth: "auto",
        margin: { left: 10, right: 10 },
        headStyles: {
          fillColor: [229, 235, 245],
          textColor: [0, 0, 0],
          valign: "middle",
          halign: "center",
          fontSize: 7,
        },
        bodyStyles: { fontSize: 7, valign: "middle" },
        columnStyles: {
          0: { halign: "center" }, // Sr.No
          1: { halign: "left" },   // Name
          2: { halign: "left" },   // Email
          3: { halign: "center" }, // Mobile No
          4: { halign: "left" },   // Organization
          5: { halign: "center" }, // Tally Number
          6: { halign: "center" }, // Participants
          7: { halign: "center" }, // Registration Date
          8: { halign: "center" }, // Mode of Meeting
        },
        styles: {
          lineColor: [0, 0, 0],
          lineWidth: 0.1,
        },
      });

      startY = doc.lastAutoTable.finalY + 10;
    });

    doc.save("Event_Registrations.pdf");
  };

  return (
    <button type="button" className="btn btn-purpal addbutton" onClick={handleDownloadPdf}>
      <PDFDownload /> Pdf
    </button>
  );
}
